import { render, staticRenderFns } from "./dialogSure.vue?vue&type=template&id=37e2d066&scoped=true"
import script from "./dialogSure.vue?vue&type=script&lang=js"
export * from "./dialogSure.vue?vue&type=script&lang=js"
import style0 from "./dialogSure.vue?vue&type=style&index=0&id=37e2d066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e2d066",
  null
  
)

export default component.exports